module.exports = __webpack_public_path__ + "img/IMG_3917.a3ce340d.jpg";